import { Anagrafica } from './anagrafica';
import { Comune } from './tipologiche/comune';
import { Materia } from "./tipologiche/materia";
import { Provincia } from './tipologiche/provincia';
import { SoggettoPratica } from "./tipologiche/soggetto-pratica";
import { TipoPersona } from './tipologiche/tipo-persona';
import { TipoSocieta } from './tipologiche/tipo-societa';
import { TipoTipologica } from "./tipologiche/tipo-tipologica";

export abstract class Persona extends Anagrafica {
    nome: string;
    cognome: string;
    codiceFiscale: string;
    dataNascita: number;
    comuneNascita: Comune;
    provinciaNascita: Provincia;
    matricola: string;
    telefono: string;
    cellulare: string;
    email: string;
    fax: string;
    pec: string;
    indirizzo: string;
    cap: string;
    sesso:string;
    vivente: boolean;
    comuneResidenza: Comune;
    provinciaResidenza: Provincia;
    partitaIva: string;
    codiceFiscaleRappresentanteLegale: string;
    ragioneSociale: string;
    dipendente: boolean;
    tipoPersona: TipoPersona;
    tipoSocieta: TipoSocieta;
    note: string;
    rimosso: boolean;
    societa: SoggettoPratica;
    tipoContratto: Materia;
    //tipoDipendente: TipoTipologica;
    statoDipendente: TipoTipologica;
    figuraProfessionale: TipoTipologica;
    unitaOrganizzativaAppartenenza: string;
    unitaorganizzativautilita: string;
    dataAssunzione: number;
    dataCessazione: number;
    nominativo: string; // usato solo lato FE

    albo: string;
    numeroIscrizione: string;
    codiceMeccanografico: string;
    statusAT: string;
    dataIscrizioneAlbo: number;
    dataIscrizioneCassa: number;

    get fullName() {
        return `${this.nome} ${this.cognome}`;
    }
}
